<app-modal [active]="batchStarted" (modalClosed)="batchStarted=false">
  <app-batch-download></app-batch-download>
</app-modal>

<div style="background-color: #f7f7ff; padding: 3rem">
  <div class="columns">
    <div class="column is-1"></div>
    <div class="column"></div>
    <div class="column is-4 search">
      <div class="columns">
        <div class="column">
          <span><input (keyup)="searchProperties()" [(ngModel)]="searchText" class="input" placeholder="Suche"
                      style="width: 300px; border-bottom: none !important;background-color: #ffffff"
                      type="text">
          </span>
        </div>
        <div class="column">
         <span style="float: right; padding: 8px">
           <svg height="24.093" viewBox="0 0 29.086 29.093" width="24.086" xmlns="http://www.w3.org/2000/svg">
             <path d="M33.245,31.481l-8.089-8.165a11.528,11.528,0,1,0-1.75,1.772L31.442,33.2a1.245,1.245,0,0,0,1.757.045A1.253,1.253,
                  0,0,0,33.245,31.481ZM16.1,25.186a9.1,9.1,0,1,1,6.438-2.666A9.047,9.047,0,0,1,16.1,25.186Z" data-name="Icon ionic-ios-search"
                  fill="#707070"
                  id="Icon_ionic-ios-search" transform="translate(-4.5 -4.493)"
             />
            </svg>
          </span>
        </div>
      </div>
    </div>
    <div class="column is-1"></div>
  </div>

  <div class="columns mt-4">
    <div class="column is-1"></div>
    <div class="column is-flex is-justify-content-space-between" style="font-size: 23px;">
      <div class="columns" style="margin-bottom: 0">
        <div class="column is-clickable" [ngClass]="showAllOrders || archived ? 'color-dark-gray' : 'color-darkblue'">
          <p class="is-unselectable" (click)="changeShownOrders(false)" style="white-space: nowrap; text-align: end;">Meine Bestellungen</p>
        </div>
        <div class="column is-clickable"  [ngClass]="showAllOrders ? 'color-darkblue' : 'color-dark-gray'" style="border-left: 2px solid #d7d7d7">
          <p class="is-unselectable" (click)="changeShownOrders(true)" style="white-space: nowrap;">Alle Bestellungen</p>
        </div>
      </div>
      <div class="columns" style="margin-bottom: 0">
        <div class="column is-clickable">
          <p class="is-unselectable" (click)="showArchivedOrders()" [ngClass]="archived ? 'color-darkblue' : 'color-dark-gray'" style="white-space: nowrap; text-align: end;">Archiv</p>
        </div>
        <div class="column" [ngClass]="loadingAvailableUsers ? 'disabled' : 'is-clickable'" style="border-left: 2px solid #d7d7d7">
          <p class="is-unselectable" (click)="loadingAvailableUsers ? $event.stopPropagation() : toggleFilterArea()" [ngClass]="filterAreaVisible ? 'color-darkblue' : 'color-dark-gray'" style="white-space: nowrap;">Filter</p>
        </div>
      </div>
    </div>
    <div class="column is-1"></div>
  </div>

  <div *ngIf="filterAreaVisible && !loadingAvailableUsers" class="columns mt-2">
    <div class="column is-1"></div>
    <div class="column delicate-shadow" style="background-color: #ffffff; border-radius: 10px; height: 100px;">
      <div class="columns">
        <div class="column is-4">
          <div class="columns" style="margin-bottom: 0">
            <p class="column h-4">Besteller</p>
          </div>
          <div class="columns">
            <div class="column">
              <label>
                <div class="select is-rounded is-small">
                  <select [formControl]="selectedUserControl">
                    <option *ngFor="let user of availableUsers;" [value]="user.id">{{user.mail}}</option>
                  </select>
                </div>
              </label>
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
    </div>
    <div class="column is-1"></div>
  </div>

  <!--properties: search results-->
  <ng-container *ngIf="searchText; else showOrders">
    <div class="columns mt-4" style="margin-bottom: 0">
      <div class="column is-1"></div>
      <div class="column"
           style="background-color: #336E99; border: 1px solid; border-bottom: none;  border-radius: 10px; color: white">
        <div class="columns delicate-shadow">
          <div class="column" style="text-align: center">Objekt-ID</div>
          <div class="column is-3">Straße</div>
          <div class="column is-1">Nr.</div>
          <div class="column is-1">PLZ</div>
          <div class="column is-2">Stadt</div>
          <div class="column"></div>
        </div>
      </div>
      <div class="column is-1"></div>
    </div>

    <div *ngIf="propertiesBySearchTerm.length > 0" id="outer-container">
      <div *ngFor="let property of propertiesBySearchTerm" class="columns mt-5" id="property">
        <div class="column is-1"></div>
        <div class="column" style="background-color: #ffffff; border-radius: 10px;height: 120px">
          <div class="columns delicate-shadow" style="height: 120px">
            <div class="column c1 has-text-centered">
              <div>
                {{property.id}}
                <div *ngIf="property.name" style="position: relative;font-size: 12px; color: #707070">
                  {{property.name}}
                </div>
              </div>
            </div>
            <div class="column c1 is-3">
              {{property.street}}
            </div>
            <div class="column c1 is-1">
              {{property.house_number}}
            </div>
            <div class="column c1 is-1">
              {{property.zip}}
            </div>
            <div class="column c1 is-2">
              {{property.town}}
            </div>
            <div class="column c1 has-text-right">
              <svg
                *ngIf="containsPropertyDocumentWithUnseenInformation(property) && !hasPropertyNecessaryActions(property)"
                height="20"
                style="position: absolute; z-index: 1; transform: translate(106px,-11px)" viewBox="0 0 24 24" width="20"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" data-name="Ellipse 29" fill="#e64b4b" id="Ellipse_29" r="12"/>
              </svg>
              <svg
                *ngIf="containsPropertyDocumentWithUnseenInformation(property) && !hasPropertyNecessaryActions(property)"
                data-name="Komponente 4 – 1"
                height="25.33" id="Komponente_4_1" style="position: absolute; z-index: 1; transform: translate(105px,-14px)" viewBox="0 0 25.33 25.33"
                width="25.33"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M20.665,8A12.665,12.665,0,1,0,33.33,20.665,12.667,12.667,0,0,0,20.665,8Zm0,5.618a2.145,2.145,0,1,1-2.145,2.145A2.145,2.145,0,0,1,20.665,13.618Zm2.86,12.971a.613.613,0,0,1-.613.613H18.418a.613.613,0,0,1-.613-.613V25.363a.613.613,0,0,1,.613-.613h.613V21.482h-.613a.613.613,0,0,1-.613-.613V19.644a.613.613,0,0,1,.613-.613h3.268a.613.613,0,0,1,.613.613v5.107h.613a.613.613,0,0,1,.613.613Z" data-name="Pfad 613"
                      fill="#d7d7d7"
                      id="Pfad_613" transform="translate(-8 -8)"/>
              </svg>

              <svg *ngIf="hasPropertyNecessaryActions(property)" height="25.063" style="position: absolute; z-index: 1; transform: translate(105px,-14px)"
                   viewBox="0 0 25.063 25.063" width="25.063"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M12.532,0A12.532,12.532,0,1,0,25.063,12.532,12.532,12.532,0,0,0,12.532,0ZM11.357,7.44a1.175,1.175,0,1,1,2.35,0v6.266a1.175,1.175,0,1,1-2.35,0Zm1.175,12.14a1.539,1.539,0,1,1,1.539-1.539,1.539,1.539,0,0,1-1.539,1.539Z" data-name="Pfad 621"
                      fill="#de1507"
                      id="Pfad_621"/>
              </svg>

              <a [state]="[property]" class="details"
                 routerLink="/order_object/{{property.id}}">Details</a>
            </div>
          </div>
        </div>
        <div class="column is-1"></div>
      </div>
    </div>

    <div *ngIf="propertiesBySearchTerm.length === 0" class="columns mt-5">
      <div class="column is-1"></div>
      <div class="column" style="background-color: #ffffff; border-radius: 10px;height: 120px">
        <div class="columns delicate-shadow" style="height: 120px">
          <div class="column c1 has-text-centered">
            <p>Es konnte kein passendes Objekt gefunden werden.</p>
          </div>
        </div>
      </div>
      <div class="column is-1"></div>
    </div>

  </ng-container>


  <!--orders-->
  <ng-template #showOrders>
    <div class="columns mt-4" style="margin-bottom: 0">
      <div class="column is-1"></div>
      <div class="column"
           style="background-color: #336E99; border: 1px solid; border-bottom: none;  border-radius: 10px; color: white">
        <div class="columns">
          <div class="column is-2"></div>
          <div class="column is-2">Auftrag</div>
          <div class="column is-2">Bestelldatum</div>
          <div class="column is-2" style="white-space: nowrap; padding-left: 0">Neue Dokumente</div>
          <div class="column is-2" style="white-space: nowrap; padding-left: 0">Alle Dokumente</div>
          <div class="column is-2"></div>
        </div>
      </div>
      <div class="column is-1"></div>
    </div>

    <div *ngIf="(filteredOrders.length === 0) && !loadingOrders && requestedOrders && !archived" class="columns">
      <div class="column is-1"></div>
      <div class="column has-text-centered delicate-shadow mt-5" style="background-color: #ffffff; border-radius: 10px;">
        <p>Sie haben noch keine Bestellung aufgegeben.</p>
      </div>
      <div class="column is-1"></div>
    </div>

    <div *ngIf="(filteredOrders.length === 0) && !loadingOrders && requestedArchivedOrders && archived" class="columns">
      <div class="column is-1"></div>
      <div class="column has-text-centered delicate-shadow mt-5" style="background-color: #ffffff; border-radius: 10px;">
        <p>Sie haben noch keine Bestellung archiviert.</p>
      </div>
      <div class="column is-1"></div>
    </div>

      <ng-container *ngIf="filteredOrders?.length > 0 && !this.loadingOrders">
          <div *ngFor="let order of getPagedData()" class="columns mt-5">
              <div class="column is-1"></div>
              <div class="column" style="background-color: #ffffff; border-radius: 10px;height: 120px">
                  <div class="columns delicate-shadow" style="height: 120px;">
                      <div class="column is-2 is-flex is-align-items-center is-justify-content-center">
                          <circle-progress class="is-flex is-align-items-center" *ngIf="hasOrderStatistics(order)"
                                           subtitle="{{progress(order) |number: '1.0-2':'de'}}%"
                                           [percent]="progress(order)"
                                           [backgroundStrokeWidth]=0
                                           [backgroundPadding]=5
                                           [radius]=35
                                           [space]=-2
                                           [outerStrokeWidth]=3
                                           [outerStrokeColor]="'#73B1D6'"
                                           [outerStrokeLinecap]="'butt'"
                                           [innerStrokeColor]="'#f7f7f7'"
                                           [innerStrokeWidth]=3
                                           [subtitleColor]="'#35566E'"
                                           [titleFontWeight]="'700'"
                                           [subtitleFontSize]="'18'"
                                           [animateTitle]=false
                                           [animationDuration]=1000
                                           [showTitle]=false
                                           [showUnits]=false
                                           [showBackground]=false
                                           [clockwise]=true
                                           [responsive]=false
                                           [startFromZero]=false
                                           [lazy]=true
                          ></circle-progress>
                          <div *ngIf="!hasOrderStatistics(order)" class="st31 is-flex is-justify-content-center is-align-items-center">
                              <ngx-skeleton-loader [theme]="{'width':'70px','height':'70px'}" appearance="circle" count="1"></ngx-skeleton-loader>
                          </div>
                      </div>
                      <div class="column is-2 c1 max-h-100">
                          {{order.orderid}}
                          <div *ngIf="order.name"
                               class="truncate info-text" [matTooltip]="order.name" appTooltip>{{order.name}}
                          </div>
                      </div>
                      <div class="column is-2 c1">
                        {{order.entrydate | date:'dd.MM.yyyy'}}
                        <div *ngIf="hasOrderStatistics(order)"
                             class="truncate info-text" matTooltip="Aufgegeben von: {{getOrderedByUsername(order)}}" appTooltip>Aufgegeben von: {{getOrderedByUsername(order)}}
                        </div>
                      </div>
                      <div class="column is-2 c2">
                        <span *ngIf="hasOrderStatistics(order)">
                          <span style="vertical-align: middle">{{amountOfNewDocs(order)}} </span>
                          <a (click)="this.loginIdService.hasPermissionsForOrder(order, 'DOWNLOAD') ? downloadForOrder(order, true) : $event.stopPropagation()"
                             *ngIf="amountOfNewDocs(order)> 0"
                             class="download" [class.insufficient-permissions]="!this.loginIdService.hasPermissionsForOrder(order, 'DOWNLOAD')"
                             style="vertical-align: middle"
                             [matTooltip]="insufficientPermissionsText(order)">Herunterladen
                          </a>
                        </span>
                        <span *ngIf="!hasOrderStatistics(order)">
                          <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'85%'}" appearance="line" count="1"></ngx-skeleton-loader>
                        </span>
                      </div>
                      <div class="column is-2 c2">
                        <span *ngIf="hasOrderStatistics(order)">
                          <span style="vertical-align: middle">{{amountOfDocs(order)}} </span>
                          <a (click)="this.loginIdService.hasPermissionsForOrder(order, 'DOWNLOAD') ? downloadForOrder(order, false) : $event.stopPropagation()"
                             *ngIf="amountOfDocs(order) > 0"
                             class="download" [class.insufficient-permissions]="!this.loginIdService.hasPermissionsForOrder(order, 'DOWNLOAD')"
                             style="vertical-align: middle"
                             [matTooltip]="insufficientPermissionsText(order)">Herunterladen
                          </a>
                        </span>
                        <span *ngIf="!hasOrderStatistics(order)">
                            <ngx-skeleton-loader
                                [theme]="{'animation':'none','margin':'2px auto','width':'85%'}"
                                appearance="line" count="1">
                            </ngx-skeleton-loader>
                        </span>
                      </div>
                      <div class="column is-1 c1">
                          <span>
                              <app-order-menu [navigationEntries]="[{name: 'Details', route: '/order_details/'+order.orderid, icon: 'assignment', orderId: order.orderid}]" [order]="order" (archiveResponse)="processArchiveResponse($event)" [cancelStatisticRequests]="cancelOrderStatisticRequests.bind(this)"></app-order-menu>
                          </span>
                      </div>
                      <div class="column is-1 c1">
                          <img class="info-icon is-clickable" routerLink="/order_details/{{order.orderid}}"
                               *ngIf="containsOrderDocumentWithUnseenInformation(order) && !hasOrderPropertyWithNecessaryActions(order)"
                               alt="Info Icon" src="assets/images/InfoIcon/info_icon_present.svg"
                          >
                          <img class="info-icon is-clickable" routerLink="/order_details/{{order.orderid}}"
                               *ngIf="hasOrderPropertyWithNecessaryActions(order)"
                               alt="Info Icon" src="assets/images/InfoIcon/ci_info_icon.svg"
                          >
                      </div>
                  </div>
              </div>
              <div class="column is-1"></div>
          </div>
      </ng-container>

      <ng-container *ngIf="loadingOrders">
          <ng-container *ngFor="let _ of [].constructor(5)">
              <div class="columns">
                  <div class="column is-1"></div>
                  <div class="column">
                      <ngx-skeleton-loader
                          [theme]="{'animation':'none','margin-top':'10px', 'margin-bottom':'-10px', 'height':'110px'}"
                          appearance="line" count="1">
                      </ngx-skeleton-loader>
                  </div>
                  <div class="column is-1"></div>
              </div>
          </ng-container>
      </ng-container>

    <div [ngClass]="{'is-invisible' : loadingOrders || filteredOrders.length === 0}" class="columns">
      <div class="column is-1"></div>
      <div class="column has-text-centered delicate-shadow mt-5" style="background-color: #ffffff; border-radius: 10px;">
        <mat-paginator #matPaginator
                       [length]="filteredOrders.length"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="[5, 10, 15, 25]"
                       (page)="onPageChange($event)">
        </mat-paginator>
      </div>
      <div class="column is-1"></div>
    </div>
  </ng-template>
</div>
